module.exports = __webpack_public_path__ + "assets/img/yyzzD.a28efd83.png";